import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

const routes = [
  { path: '', redirect: '/login' },
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    name: 'LoginView',
    component: () => import('@/views/LoginView.vue'),
    hidden: true,
  },
  {
    path: '/homeview',
    name: 'HomeView',
    component: HomeView,
    // component: () => import('@/views/HomeView.vue'),
  },
  {
    path: '/over',
    name: 'OverView',
    // redirect: 'home',
    component: () => import('@/views/home/OverView.vue'),
    children: [
      { path: '/', redirect: 'home' },
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/OverView/home.vue'),
      },
      {
        path: 'picture',
        name: 'PictureView',
        component: () => import('@/views/home/OverView/pictureView.vue'),
      },
      {
        path: 'article',
        name: 'ArticleView',
        component: () => import('@/views/home/OverView/articleView.vue'),
      },
      {
        path: 'video',
        name: 'VideoView',
        component: () => import('@/views/home/OverView/videoView.vue'),
      },
      {
        path: 'custom',
        name: 'customView',
        component: () => import('@/views/home/OverView/customView.vue'),
      },
      {
        path: 'set',
        name: 'setView',
        component: () => import('@/views/home/OverView/setView.vue'),
      },
      {
        path: 'microdisk',
        name: 'MicroDisk',
        component: () => import('@/views/home/OverView/microDisk.vue'),
      },
      {
        path: 'groupface',
        name: 'groupface',
        component: () => import('@/views/home/OverView/groupface.vue'),
      },
      {
        path: 'haibao',
        name: 'haibao',
        component: () => import('@/views/home/OverView/haibao.vue'),
      },
      {
        path: 'updata_haibao',
        name: 'updata_haibao',
        component: () => import('@/views/home/OverView/updata_haibao.vue'),
      },
      {
        path: 'singleless',
        name: 'SingleLess',
        component: () => import('@/views/home/OverView/singleLess.vue'),
        children: [
          {
            path: 'newarticle',
            name: 'NewArticle',
            component: () => import('@/views/home/OverView/newArticle.vue'),
            hidden: true,
          },
        ],
      },
      {
        path: 'specialcolumn',
        name: 'SpecialColumn',
        component: () => import('@/views/home/OverView/specialColumn.vue'),
        children: [
          {
            path: 'newvideo',
            name: 'NewVideo',
            component: () => import('@/views/home/OverView/newVideo.vue'),
            hidden: true,
          },
        ],
      },
      {
        path: 'course',
        name: 'Course',
        component: () => import('@/views/home/OverView/course.vue'),
        children: [{
          path: 'coursedetail',
          name: 'courseDetails',
          component: () => import('@/views/home/OverView/coursedetail.vue'),
          hidden: true,
        }, {
          path: 'newcourse',
          name: 'NewCourse',
          component: () => import('@/views/home/OverView/newCourse.vue'),
          hidden: true,
        },
        ],
      },
      {
        path: 'list',
        name: 'UserList',
        component: () => import('@/views/home/UserView/userList.vue'),
      },
      {
        path: 'active',
        name: 'UserActive',
        component: () => import('@/views/home/UserView/userActive.vue'),
      },
      {
        path: 'renewal',
        name: 'UserRenewal',
        component: () => import('@/views/home/UserView/userRenewal.vue'),
      },
      {
        path: 'details',
        name: 'UserDetails',
        component: () => import('@/views/home/UserView/userDetails.vue'),
      },
    ],
  },
  {
    path: '/index',
    name: 'IndexView',
    // redirect: '/index/host',
    component: () => import('@/views/index/index.vue'),
    children: [
      { path: '/', redirect: 'host' },
      {
        path: 'host/:id?',
        name: 'Host',
        component: () => import('@/views/index/indexView/home.vue'),
      },
      {
        path: 'footsteps',
        name: 'FootSteps',
        component: () => import('@/views/index/dropdown/footsteps.vue'),
        children: [
          {
            path: 'themedetail',
            name: 'themeDetail',
            component: () => import('@/views/index/dropdown/themeDetail.vue'),
            hidden: true,
          },
        ],
      },
      {
        path: 'favorites',
        name: 'Favorites',
        component: () => import('@/views/index/dropdown/favorites.vue'),
      },
      {
        path: 'search',
        name: 'SearchView',
        component: () => import('@/views/index/indexView/SearchView.vue'),
      },
      {
        path: 'join',
        name: 'PaidJoin',
        component: () => import('@/views/index/indexView/paidJoin.vue'),
      },
      // {
      //   path: 'themedetail',
      //   name: 'themeDetail',
      //   component: () => import('@/views/index/dropdown/themeDetail.vue'),
      //   // hidden: true,
      // },
    ],
  },
]

// const RouterConfig = {
//   mode: 'history', // require service support
//   scrollBehavior: () => ({
//     y: 0,
//   }),
//   routes,
// }

// export const router = new Router(RouterConfig)
// const createRouter = () => new VueRouter(RouterConfig)

// const router = createRouter()

export const router = new VueRouter({
  routes,
})
router.beforeEach(function (to, from, next) {
  const user = localStorage.getItem('user')
  if (user) {
    return next()
  } else {
    // 未登录状态下，如果访问主页路由并且携带有圈子ID，直接重定向到付费加入页面，并将ID带上
    if (to.path.startsWith('/index/host/') && to.params.id) {
      return next({ path: '/index/join', query: { groupid: to.params.id } })
    }
    // 允许免登录直接打开付费加入页面，以及登录页和根目录
    if (
      to.path == '/login' ||
      to.path == '/' ||
      to.path == '' ||
      to.path == '/index/join'
    ) {
      return next()
    } else {
      next('/login')
    }
  }
})
// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title; // 设置标题
  } else {
    document.title = '识圈'; // 备用标题
  }
  next();
});
export default router
